export function checkEditorMode(): boolean {
  if (typeof window === 'undefined') return false;

  try {
    return parent.window !== window;
  } catch (e) {
    console.log('Error in checkEditorMode:', e);
    return false;
  }
}
